import React, { useState, useEffect, useCallback } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Types } from 'mongoose';

import { toastr } from 'react-redux-toastr';
import { getVoiceItemSettings } from '../../../util/getVoiceItemSettings';
import { BotsCreators } from '../../../store/actions/bots';
import { ItemsCreators } from '../../../store/actions/items';
import { ConnectorsCreators } from '../../../store/actions/connectors';
import * as BotCreatorActions from '../../../store/actions/bot-creator';

import './index.scss';

import LeftMenu from '../../../components/Builder/LeftMenu';
import RightMenu from '../../../components/Builder/RightMenu';
import Container from '../../../components/Builder/Container';

import defaultScriptCode from '../../../util/defaultScriptCode';

const BuilderTab = (props) => {
  const [showLeftMenu, setShowLeftMenu] = useState(false);
  const [selectedPathId, setSelectedPathId] = useState(null);
  const [triggerGroup, setTriggerGroup] = useState(false);

  const {
    listItemsRequest,
    retrieveBotRequest,
    getConnectorsRequest,
    getAllItems,
    getAllConnectors,
    items,
    allItems,
    resetBotCreator,
    resetItems,
  } = props;

  useEffect(() => {
    const { botid } = props.match.params;
    retrieveBotRequest(botid);
    listItemsRequest(botid);
    getAllItems({ botId: botid });
    getAllConnectors({ botId: botid });
    getConnectorsRequest(botid);

    return () => {
      resetBotCreator();
      resetItems();
    };
  }, []);

  const deleteItem = (item) => {
    const { removeItemRequest, removeVoiceItemRequest } = props;

    const isVoiceItem = item.type?.startsWith('Voice');

    if (isVoiceItem) {
      removeVoiceItemRequest(props.item);
    } else {
      removeItemRequest(item);
    }
  };

  const cloneItem = (item, targetWidth) => {
    const { cloneItemRequest, cloneVoiceItemRequest } = props;

    const isVoiceItem = item.type?.startsWith('Voice');

    if (isVoiceItem) {
      cloneVoiceItemRequest(item, targetWidth);
    } else {
      cloneItemRequest(item, targetWidth);
    }
  };

  const onSelectedPathId = (id) => {
    setSelectedPathId(id);
  };

  const createChatItem = async (position, item, option) => {
    const { createItemRequest, bot, currentFlow } = props;
    const { id } = currentFlow;

    const { botid } = props.match.params;

    const defaultMenuItems = [];
    for (let i = 0; i < 3; i++) {
      if (option.type === 'MenuAI') {
        defaultMenuItems.push({
          _id: Types.ObjectId().toString(),
          description: '',
          child: null,
          intent: '',
        });
      } else {
        defaultMenuItems.push({
          _id: Types.ObjectId().toString(),
          description: '',
          child: null,
        });
      }
    }

    const optionsType = [
      'Text',
      'Image',
      'Video',
      'Audio',
      'Document',
      'Menu',
      'Collect',
      'Conditional',
      'API',
      'APIV2',
      'SMS',
      'EMAIL',
      'Script',
      'Module',
      'Human',
      'DynamicMedia',
      'VTexAddToCart',
      'VTexUpdateCart',
      'VTexRemoveFromCart',
      'VTexOrderList',
      'VTexCatalogProduct',
      'VTexCatalogProducts',
      'VTexCartProduct',
      'VTexCheckout',
      'ZendeskCreateRequest',
      'ZendeskListRequests',
      'ZendeskShowRequest',
      'ZendeskListComments',
      'ZendeskInsertComment',
      'ZendeskAttachFile',
      'ZendeskUpdateStatusRequest',
      'JiraCreateIssue',
      'JiraListIssues',
      'JiraShowIssue',
      'JiraListProjects',
      'JiraListStatus',
      'JiraListRequestypes',
      'JiraListPriorities',
      'JiraListComments',
      'JiraInsertComment',
      'JiraAttachFile',
      'JiraUpdateStatusIssue',
      'Carousel',
      'Form',
      'Group',
      'Redirect',
      'BotTransfer',
      'MenuAI',
      'RdStationInput',
      'RdStationSubmitLead',
      'GlpiCreateRequest',
      'GlpiListRequests',
      'GlpiShowRequest',
      'GlpiListComments',
      'GlpiInsertComment',
      'GlpiAttachFile',
      'GlpiUpdateStatusRequest',
      'GlpiListGroups',
    ];

    if (!optionsType.includes(option.type)) return;

    const body = {
      title: option.type === 'Collect' ? 'Bloco de coleta' : 'Nome',
      description: [''],
      option,
      positionOnScreen: position,
      type: option.type,
      menuItems:
        option.type === 'Menu' || option.type === 'MenuAI'
          ? defaultMenuItems
          : [],
      captureAnswer:
        option.type === 'Menu' ||
        option.type === 'Collect' ||
        option.type === 'Human' ||
        option.type === 'ZendeskAttachFile' ||
        option.type === 'JiraAttachFile' ||
        option.type === 'RdStationInput' ||
        option.type === 'GlpiAttachFile',
      timeTypping: 1,
      randomTextActive: false,
      quickAccess: false,
      confidence: null,
    };

    if (option.type === 'Menu') {
      body.validationType = 5;
      body.validation = '^[0-9]+$';
    }

    if (option.type === 'Conditional') {
      body.collections = [];
      body.conditions = [];
    }

    if (option.type === 'Image') {
      body.thumbnailUrl = '';
      body.fileUrl = '';
    }

    if (option.type === 'DynamicMedia') {
      body.variableUrl = '';
    }

    if (option.type === 'Collect') {
      body.acceptFiles = [];
    }

    if (option.type === 'Script') {
      body.scriptCode = defaultScriptCode;
    }

    if (option.type === 'Carousel') {
      body.carousel = {
        cards: [],
      };
    }

    if (option.type === 'VTexAddToCart' || option.type === 'VTexUpdateCart') {
      body.vtex = {
        appKey: '',
        appToken: '',
        baseUrl: '',
        productIndex: '',
        quantity: '',
      };
    }

    if (option.type === 'VTexRemoveFromCart') {
      body.vtex = {
        appKey: '',
        appToken: '',
        baseUrl: '',
        productIndex: '',
        conditionEscape: '',
      };
    }

    if (option.type === 'VTexCartProduct') {
      body.vtex = {
        productIndex: '',
      };
    }
    if (option.type === 'VTexCatalogProduct') {
      body.vtex = {
        conditionEscape: '',
      };
    }

    if (option.type === 'VTexCatalogProducts') {
      body.vtex = {
        appKey: '',
        appToken: '',
        baseUrl: '',
        category: '',
        conditionEscape: '',
      };
    }

    if (option.type === 'VTexOrderList') {
      body.vtex = {
        appKey: '',
        appToken: '',
        baseUrl: '',
        orderListVariable: '',
      };
    }

    if (option.type === 'VTexCheckout') {
      body.vtex = {
        appKey: '',
        appToken: '',
        baseUrl: '',
        checkoutUrlVariable: '',
        orderValueVariable: '',
        minimumOrderValueVariable: '',
        restValueToMinimumVariable: '',
      };
    }

    if (option.type === 'ZendeskCreateRequest') {
      body.zendesk = {
        email: '',
        requester: '',
        subject: '',
        comment: '',
      };
    }

    if (option.type === 'ZendeskListRequests') {
      body.zendesk = {
        email: '',
        password: '',
        quantity: '',
        status: '',
        header: '',
        customList: [],
      };
    }

    if (option.type === 'ZendeskShowRequest') {
      body.zendesk = {
        email: '',
        password: '',
        requestId: '',
      };
    }

    if (option.type === 'ZendeskListComments') {
      body.zendesk = {
        email: '',
        password: '',
        requestId: '',
        header: '',
        quantity: '',
      };
    }

    if (option.type === 'ZendeskInsertComment') {
      body.zendesk = {
        email: '',
        password: '',
        requestId: '',
        comment: '',
      };
    }

    if (option.type === 'ZendeskAttachFile') {
      body.zendesk = {
        email: '',
        password: '',
        requestId: '',
        comment: '',
      };
    }

    if (option.type === 'ZendeskUpdateStatusRequest') {
      body.zendesk = {
        email: '',
        password: '',
        requestId: '',
      };
    }

    if (option.type === 'Group') {
      body.subflowLength = 0;
      body.lockConnectorFrom = true;
    }

    if (option.type === 'Redirect') {
      body.redirectTo = null;
      body.lockConnectorFrom = true;
    }

    if (option.type === 'BotTransfer') {
      body.botTransfer = {
        id: '',
        exportVariables: false,
      };
      body.lockConnectorFrom = true;
    }

    if (option.type === 'JiraCreateIssue') {
      body.jira = {
        reporterEmail: '',
        projectId: '',
        summary: '',
        description: '',
        requestTypeId: '',
      };
    }

    if (option.type === 'JiraListIssues') {
      body.jira = {
        reporterEmail: '',
        password: '',
        projectId: '',
        quantity: '',
      };
    }

    if (option.type === 'JiraShowIssue') {
      body.jira = {
        reporterEmail: '',
        password: '',
        issueId: '',
      };
    }

    if (option.type === 'JiraListProjects') {
      body.jira = {};
    }

    if (option.type === 'JiraListStatus') {
      body.jira = {
        issueId: '',
      };
    }

    if (option.type === 'JiraListRequestypes') {
      body.jira = {
        projectId: '',
      };
    }

    if (option.type === 'JiraListPriorities') {
      body.jira = {};
    }

    if (option.type === 'JiraListComments') {
      body.jira = {
        reporterEmail: '',
        password: '',
        issueId: '',
      };
    }

    if (option.type === 'JiraInsertComment') {
      body.jira = {
        reporterEmail: '',
        password: '',
        issueId: '',
        comment: '',
      };
    }

    if (option.type === 'JiraAttachFile') {
      body.jira = {
        reporterEmail: '',
        password: '',
        issueId: '',
      };
    }

    if (option.type === 'JiraUpdateStatusIssue') {
      body.jira = {
        reporterEmail: '',
        password: '',
        issueId: '',
        statusId: '',
      };
    }

    if (option.type === 'RdStationInput') {
      body.rdStationInput = {
        question: '',
        uuid: '',
        label: { default: '' },
        name: { default: '' },
        apiIdentifier: '',
        customField: false,
        validationRules: {},
        presentationType: '',
        dataType: '',
      };
    }

    if (option.type === 'RdStationSubmitLead') {
      body.rdStationSubmitLead = {
        conversionIdentifier: '',
      };
    }

    if (option.type === 'GlpiCreateRequest') {
      body.glpi = {
        email: '',
        login: '',
        password: '',
        requester: '',
        subject: '',
        group: '',
        comment: '',
        requirePassword: false,
      };
    }

    if (option.type === 'GlpiListRequests') {
      body.glpi = {
        login: '',
        password: '',
        quantity: '',
        status: '',
        header: '',
        customList: [],
      };
    }

    if (option.type === 'GlpiShowRequest') {
      body.glpi = {
        login: '',
        password: '',
        requestId: '',
      };
    }

    if (option.type === 'GlpiListComments') {
      body.glpi = {
        login: '',
        password: '',
        requestId: '',
        header: '',
        quantity: '',
      };
    }

    if (option.type === 'GlpiInsertComment') {
      body.glpi = {
        login: '',
        password: '',
        requestId: '',
        comment: '',
      };
    }

    if (option.type === 'GlpiAttachFile') {
      body.glpi = {
        login: '',
        password: '',
        requestId: '',
      };
    }

    if (option.type === 'GlpiUpdateStatusRequest') {
      body.glpi = {
        login: '',
        password: '',
        requestId: '',
      };
    }

    if (option.type === 'GlpiListGroups') {
      body.glpi = {};
    }

    if (option.orphan) {
      body.orphan = option.orphan;
    }
    if (item) {
      body.position = (item.position || -1) + 1;
    } else {
      body.position = 0;
    }

    if (option.fromRoot) {
      body.fromRoot = option.fromRoot;
    }

    if (option.type === 'Menu' || option.type === 'Text') {
      body.useIA = bot.iaStatus;
    }

    if (option.type === 'MenuAI') {
      body.useIA = true;
      body.captureAnswer = true;
      body.AILocal = true;
    }

    await createItemRequest(botid, body, id);
  };

  const createVoiceItem = async (position, item, option) => {
    const { createVoiceItemRequest } = props;
    const { botid } = props.match.params;

    const body = getVoiceItemSettings(option.type, position);

    if (!body) return;

    body.option = option;

    if (option.orphan) {
      body.orphan = option.orphan;
    }

    if (item) {
      body.position = (item.position || -1) + 1;
    } else {
      body.position = 0;
    }

    if (option.fromRoot) {
      body.fromRoot = option.fromRoot;
    }

    await createVoiceItemRequest({ botid, item: body });
  };

  const createItem = (position, item, option) => {
    const itemType = option?.type || item?.type;
    const isVoiceItem = itemType?.startsWith('Voice');

    if (isVoiceItem) {
      createVoiceItem(position, item, option);
      return;
    }

    createChatItem(position, item, option);
  };

  const showRightMenu = (e, item) => {
    if (item && item.path) {
      const { setCurrentPath } = props;
      setCurrentPath(item.connector);
    } else {
      const { setCurrentItem } = props;

      setCurrentItem(item);

      const { updateSelectedItem } = props;

      updateSelectedItem(item);
    }
  };

  const editDescriptionBlur = (item) => {
    const { editItemDescriptionRequest, bot } = props;

    editItemDescriptionRequest(bot._id, item._id, item.description);
  };

  const editDescription = (item, description) => {
    const { editItemDescription } = props;

    editItemDescription(item, description);
  };

  const editTitleBlur = (e) => {
    const { editItemTitleRequest, bot } = props;

    editItemTitleRequest(bot._id, e.target.id, e.target.value);
  };

  const editTitle = (item, title, e) => {
    const { editItemTitle } = props;
    editItemTitle(item, title);
    if (e.target.value === '') {
      e.target.value = e.target.placeholder + e.target.value;
      e.target.placeholder = '';
    }
  };

  const editFile = (e, item) => {
    if (e.target.files) {
      return onFileChange(e, e.target.files[0], item);
    }
    return onFileChange(e, null, item);
  };

  const editUrlBlur = (e, item) => {
    if ((e.oldValue && e.oldValue === e.target.value) || !e.target.value) {
      return;
    }

    const { editItemUrlRequest, bot } = props;

    editItemUrlRequest(bot._id, item._id, e.target.value, item);
  };

  const updateRandomText = (item) => {
    console.log('updateRandomTextRequest', item);
    const { updateRandomTextRequest, bot } = props;
    updateRandomTextRequest(bot._id, item._id, item.randomTextActive);
  };

  const editMenuItemsBlur = (item) => {
    const { editMenuItemsRequest, bot } = props;
    editMenuItemsRequest(bot._id, item._id, item.menuItems);
  };

  const editMenuItems = (item, menuItems) => {
    const { editMenuItems } = props;
    editMenuItems(item, menuItems);
  };

  const onDragEnter = (e) => {};

  const onDragLeave = (e) => {};

  const onDragOver = (e) => {};

  const onDrop = (e, item) => {
    return onFileChange(e, e.dataTransfer.files[0], item);
  };

  const onFileChange = (e, file, item) => {
    const { editItemFileRequest, removeItemFileRequest, bot } = props;

    if (file) {
      if (item.type === 'Video') {
        const pattern = /video\/mp4/;
        if (!file.type.match(pattern)) {
          toastr.error('Ops', 'Formato inválido.');
          return;
        }

        if (file.size >= 16777216) {
          // 16 Mb
          toastr.error(
            'Ops',
            'Desculpe, mas a plataforma aceita videos de até 16mb.'
          );
          return;
        }
      } else if (item.type === 'Image') {
        const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];

        const ext = file.name.split('.')[1];

        if (!validExtensions.includes(ext)) {
          toastr.error('Ops', 'Formato inválido.');
          return;
        }

        if (file.size >= 16777216) {
          // 16 Mb
          toastr.error(
            'Ops',
            'Desculpe, mas a plataforma aceita imagens de até 16mb.'
          );
          return;
        }
      } else if (item.type === 'Audio') {
        const validExtensions = ['mp3', 'wav', 'oga', 'ogg', 'mpga'];

        const ext = file.name.split('.')[1];

        if (file.size >= 16777216) {
          // 16 Mb
          toastr.error(
            'Ops',
            'Desculpe, mas a plataforma aceita audios de até 16mb.'
          );
          return;
        }
        if (!validExtensions.includes(ext)) {
          toastr.error('Ops', 'Desculpe, mas o formato inserido é inválido.');
          return;
        }
      } else if (item.type === 'Document') {
        if (file.size >= 104857600) {
          // 100 Mb
          toastr.error(
            'Ops',
            'Desculpe, mas a plataforma aceita somente documentos de até 100mb.'
          );
          return;
        }
      }
      editItemFileRequest(bot._id, e.target.dataset.id, file, item);
    } else {
      removeItemFileRequest(bot._id, item._id, item);
    }
  };

  const saveViewPosition = (viewPosition) => {
    const { saveBotViewPosition, bot } = props;
    saveBotViewPosition(bot._id, viewPosition);
  };

  const getMousePos = useCallback(
    (event) => {
      const { bot } = props;

      const zoomAreaOffset = document
        .querySelector('.builder__zoom-area')
        .getBoundingClientRect();

      return {
        x: (event.clientX - zoomAreaOffset.x) / bot?.viewPosition?.zoomLevel,
        y: (event.clientY - zoomAreaOffset.y) / bot?.viewPosition?.zoomLevel,
      };
    },
    [props.bot?.viewPosition?.zoomLevel]
  );

  const handleDrop = async (e) => {
    const { bot } = props;

    e.preventDefault();

    const resizeAmount = 1 / (bot.viewPosition?.zoomLevel || 1);
    console.log('resizeAmount: ', resizeAmount);
    const halfSquareWidth = resizeAmount - 200 / 2;
    const halfSquareHeight = resizeAmount - 90;

    const pos = [
      getMousePos(e).x + halfSquareWidth - (bot.viewPosition?.panX || 300),
      getMousePos(e).y + halfSquareHeight - (bot.viewPosition?.panY || 50),
    ];

    createItem(pos, null, {
      type: e.dataTransfer.getData('text'),
      orphan: true,
    });
  };

  const groupTrigger = () => {
    setTriggerGroup(!triggerGroup);
  };

  return (
    <>
      <LeftMenu
        show={showLeftMenu}
        showLeftMenu={setShowLeftMenu}
        botId={props.bot && props.bot._id}
      />
      <div className="col-md-12 conteudo-criador">
        {
          props.bot && props.bot._id ? (
            <Container
              items={items}
              allItems={allItems}
              createItem={createItem}
              showRightMenu={showRightMenu}
              showLeftMenu={setShowLeftMenu}
              editDescription={editDescription}
              editDescriptionBlur={editDescriptionBlur}
              editTitle={editTitle}
              editTitleBlur={editTitleBlur}
              editFile={editFile}
              editUrlBlur={editUrlBlur}
              editMenuItems={editMenuItems}
              editMenuItemsBlur={editMenuItemsBlur}
              updateRandomText={updateRandomText}
              onDragEnter={onDragEnter}
              onDragLeave={onDragLeave}
              onDragOver={onDragOver}
              onDrop={onDrop}
              saveViewPosition={saveViewPosition}
              handleDrop={handleDrop}
              viewPosition={
                props.bot.viewPosition || {
                  panX: 300,
                  panY: 50,
                  zoomLevel: 1.0,
                }
              }
              bot={props.bot}
              onSelectedPathId={onSelectedPathId}
              deleteItem={deleteItem}
              cloneItem={cloneItem}
              triggerGroup={triggerGroup}
            />
          ) : null // todo: replace null here for a load indicator
        }
        <RightMenu
          nome="RightMenu"
          show={props.showRightMenu}
          showRightMenu={showRightMenu}
          groupTrigger={groupTrigger}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  items: state.items.list,
  allItems: state.items.allItems,
  currentFlow: state.items.currentFlow,
  variables: state.items.variables,
  bot: state.bots.bot,
  connectors: state.connectors.list,
  showRightMenu: state.items.showRightMenu,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...ItemsCreators,
      ...BotsCreators,
      ...ConnectorsCreators,
      ...BotCreatorActions,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BuilderTab)
);
